export const GET_BARCODE_ITEMS = 'GET_BARCODE_ITEMS';
export const GET_BARCODE_ITEMS_SUCCESS = 'GET_BARCODE_ITEMS_SUCCESS';
export const GET_BARCODE_ITEMS_FAILURE = 'GET_BARCODE_ITEMS_FAILURE';
export const SHOW_INVALID_BARCODE_DETAILS = 'SHOW_INVALID_BARCODE_DETAILS';
export const RESET_BARCODE_ITEMS = 'RESET_BARCODE_ITEMS';
export const SHOW_INVALID_BARCODE_POPUP = 'INVALID_BARCODE_POPUP';
export const RESET_INVALID_BARCODE_DETAILS = 'RESET_INVALID_BARCODE_DETAILS';
export const SET_BARCODE_RECEIVE_ITEMS = 'SET_BARCODE_RECEIVE_ITEMS';
export const VALIDATE_REPORT_ACCOUNT = 'VALIDATE_REPORT_ACCOUNT';
export const VALIDATE_ACCOUNT = 'SCHEDULE_VALIDATE_ACCOUNT';
export const RESET_VALIDATE_ACCOUNT = 'SCHEDULE_RESET_VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'SCHEDULE_VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE = 'SCHEDULE_VALIDATE_ACCOUNT_FAILURE';
export const RESET_REPORT_USAGE_STATES = 'USAGE: RESET_REPORT_USAGE_STATES';
export const STORE_SURGERY_DETAILS = 'USAGE: STORE_SURGERY_DETAILS';
export const SET_PROGRESS_BAR_STATUS = 'USAGE: SET_PROGRESS_BAR_STATUS';
export const RESET_PROGRESS_BAR_STATUS = 'USAGE: RESET_PROGRESS_BAR_STATUS';
export const SET_REFRESH_FLAG = 'USAGE: SET_REFRESH_FLAG';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'USAGE: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_REPLENISHMENT_SURGERY_DATE =
    'USAGE:SET_REPLENISHMENT_SURGERY_DATE';
export const SET_SURGERY_NUMBER = 'USAGE:SET_SURGERY_NUMBER';
export const SET_PROGRESS_BAR_EDIT_MODE = 'USAGE: SET_PROGRESS_BAR_EDIT_MODE';
export const SET_ADVANCE_ENERGY_DATA = 'USAGE: SET_ADVANCE_ENERGY_DATA';
export const EDIT_USAGE_DETAILS = 'USAGE: EDIT_USAGE_DETAILS';
export const GET_USAGE_DETAILS = 'USAGE: GET_USAGE_DETAILS';
export const GET_USAGE_DETAILS_SUCCESS = 'USAGE: GET_USAGE_DETAILS_SUCCESS';
export const GET_USAGE_DETAILS_DISCREPENCY_SUCCESS =
    'USAGE: GET_USAGE_DETAILS_DISCREPENCY_SUCCESS';
export const GET_USAGE_DETAILS_DISCREPENCY_FAILURE =
    'USAGE: GET_USAGE_DETAILS_DISCREPENCY_FAILURE';
    export const SET_PROCEDURE_VALUE = 'USAGE: SET_PROCEDURE_VALUE';
export const GET_USAGE_DETAILS_FAILURE = 'USAGE: GET_USAGE_DETAILS_FAILURE';
export const SET_PATIENT_DETAILS = 'USAGE: SET_PATIENT_DETAILS';
export const SET_DISCREPENCY_FILES_UPLOADED =
    'USAGE: SET_DISCREPENCY_FILES_UPLOADED';

export const GET_PRICES_FOR_ITEMS = 'USAGE: GET_PRICES_FOR_ITEMS';
export const GET_PRICES_FOR_ITEMS_SUCCESS =
    'USAGE: GET_PRICES_FOR_ITEMS_SUCCESS';
export const GET_PRICES_FOR_ITEMS_FAILURE =
    'USAGE: GET_PRICES_FOR_ITEMS_FAILURE';

export const SET_ITEMS_DURING_PRICING = 'USAGE:SET_ITEMS_DURING_PRICING';

export const RESET_VALIDATED_DATA = 'USAGE: RESET_VALIDATED_DATA';

export const GET_DROPDOWN_OPTIONS = 'USAGE: GET_DROPDOWN_OPTIONS';
export const GET_DROPDOWN_OPTIONS_SUCCESS =
    'USAGE: GET_DROPDOWN_OPTIONS_SUCCESS';
export const GET_DROPDOWN_OPTIONS_FAILURE =
    'USAGE: GET_DROPDOWN_OPTIONS_FAILURE';

export const GET_PRICE_OVERRIDE_REASONS = 'USAGE: GET_PRICE_OVERRIDE_REASONS';
export const GET_PRICE_OVERRIDE_REASONS_SUCCESS =
    'USAGE: GET_PRICE_OVERRIDE_REASONS_SUCCESS';
export const GET_PRICE_OVERRIDE_REASONS_FAILURE =
    'USAGE: GET_PRICE_OVERRIDE_REASONS_FAILURE';
export const SET_INVALID_ITEM_STATUS = 'USAGE:SET_INVALID_ITEM_STATUS';

export const VALIDATE_MAZOR_CODE = 'USAGE: VALIDATE_MAZOR_CODE';
export const VALIDATE_MAZOR_CODE_RESPONSE =
    'USAGE: VALIDATE_MAZOR_CODE_RESPONSE';

export const GET_PROCEDURE_INFO = 'USAGE: GET_PROCEDURE_INFO';
export const GET_PROCEDURE_INFO_SUCCESS = 'USAGE: GET_PROCEDURE_INFO_SUCCESS';
export const GET_PROCEDURE_INFO_FAILURE = 'USAGE: GET_PROCEDURE_INFO_FAILURE';

export const VALIDATE_REPLEN_PRODUCTS = 'USAGE: VALIDATE_REPLEN_PRODUCTS';
export const VALIDATE_REPLEN_PRODUCTS_RESPONSE =
    'USAGE: VALIDATE_REPLEN_PRODUCTS_RESPONSE';

export const VALIDATE_PRODUCT_DETAILS = 'USAGE: VALIDATE_PRODUCT_DETAILS';
export const VALIDATE_PRODUCT_DETAILS_SUCCESS =
    'USAGE: VALIDATE_PRODUCT_DETAILS_SUCCESS';
export const VALIDATE_PRODUCT_DETAILS_FAILURE =
    'USAGE: VALIDATE_PRODUCT_DETAILS_FAILURE';

export const VALIDATE_REPLEN = 'USAGE: VALIDATE_REPLEN';
export const VALIDATE_REPLEN_SUCCESS = 'USAGE: VALIDATE_REPLEN_SUCCESS';
export const VALIDATE_REPLEN_FAILURE = 'USAGE: VALIDATE_REPLEN_FAILURE';
export const CLEAR_VALIDATE_REPLEN = 'USAGE: CLEAR_VALIDATE_REPLEN';
export const CLEAR_ERROR = 'USAGE: CLEAR_ERROR';

export const VALIDATE_UNID_PLAN_FEE_ITEMS =
    'USAGE: VALIDATE_UNID_PLAN_FEE_ITEMS';
export const VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS =
    'USAGE: VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS';
export const VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE =
    'USAGE: VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE';

export const USAGE_ATTACHMENT_UPLOAD = 'USAGE: USAGE_ATTACHMENT_UPLOAD';
export const USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'USAGE: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'USAGE: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const USAGE_ATTACHMENT_UPLOAD_FAILURE =
    'USAGE: USAGE_ATTACHMENT_UPLOAD_FAILURE';
export const RESET_PO_ATTACHMENT = 'RESET_PO_ATTACHMENT';
export const UPDATE_USAGE_ORDER = 'USAGE: UPDATE_USAGE_ORDER';
export const UPDATE_USAGE_ORDER_SUCCESS = 'USAGE: UPDATE_USAGE_ORDER_SUCCESS';
export const UPDATE_USAGE_ORDER_FAILURE = 'USAGE: UPDATE_USAGE_ORDER_FAILURE';

export const CREATE_USAGE_ORDER = 'USAGE: CREATE_USAGE_ORDER';
export const CREATE_USAGE_ORDER_SUCCESS = 'USAGE: CREATE_USAGE_ORDER_SUCCESS';

export const GET_IMAGE_PO_PREVIEW = 'USAGE: GET_IMAGE_PO_PREVIEW';
export const GET_IMAGE_PO_PREVIEW_SUCCESS =
    'USAGE: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const GET_IMAGE_PO_PREVIEW_FAILURE =
    'USAGE: GET_IMAGE_PO_PREVIEW_FAILURE';
export const DELETE_ATTACHMENT_REQUEST = 'USAGE: DELETE_ATTACHMENT_REQUEST';
export const DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'USAGE: DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const DELETE_ATTACHMENT_REQUEST_FAILURE =
    'USAGE: DELETE_ATTACHMENT_REQUEST_FAILURE';

export const SET_SELECT_ACCOUNT = 'USAGE: SET_SELECT_ACCOUNT';
export const STORE_ITEM_TABLE_DATA = 'USAGE: STORE_ITEM_TABLE_DATA';
export const SET_ALL_ACCOUNT_OWNED_SELECTED =
    'USAGE: SET_ALL_ACCOUNT_OWNED_SELECTED';
export const SET_PROCEDURE_DETAILS = 'USAGE: SET_PROCEDURE_DETAILS';

export const STORE_UNID_SURGERY_INFO = 'USAGE: STORE_UNID_SURGERY_INFO';

export const SET_UNID_SELECTED = 'USAGE: SET_UNID_SELECTED';
export const SAVE_OR_REPORT_DATA = 'USAGE: SAVE_OR_REPORT_DATA';

export const CLEAR_SPECFIC_DROPDOWN_LIST = 'USAGE: CLEAR_SPECFIC_DROPDOWN_LIST';
export const RESET_DROPDOWN_OPTIONS = 'USAGE: RESET_DROPDOWN_OPTIONS';

export const SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP =
    'USAGE: SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP';

export const RESET_IMAGE_PO_PREVIEW = 'USAGE: RESET_IMAGE_PO_PREVIEW';

export const SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP =
    'NO USAGE: SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP';
export const CANCEL_USAGE_ORDER = 'NO USAGE: CANCEL_USAGE_ORDER';
export const CANCEL_USAGE_ORDER_COMPLETION =
    'NO USAGE: CANCEL_USAGE_ORDER_COMPLETION';
export const SET_SHOW_CONTACT_LOGISTICS_POPUP =
    'NO USAGE: SET_SHOW_CONTACT_LOGISTICS_POPUP';

export const RESET_CANCEL_USAGE_STATES = 'NO USAGE: RESET_CANCEL_USAGE_STATES';

export const SET_PRICEOVERRIDE_DETAILS = 'USAGE: SET_PRICEOVERRIDE_DETAILS';

export const SET_USAGE_SURGERY_DETAIL_INSIDE =
    'SHIPPING: SET_USAGE_SURGERY_DETAIL_INSIDE';
export const SET_USAGE_SURGERY_DETAIL_OUTSIDE =
    'SHIPPING: SET_USAGE_SURGERY_DETAIL_OUTSIDE';

export const GET_SHIP_TO_ADDRESS_REPORT_USAGE =
    'SHIPPING: GET_SHIP_TO_ADDRESS_REPORT_USAGE';

export const GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS =
    'SHIPPING: GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS';
export const GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE =
    'SHIPPING: GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE';

export const GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS =
    'SHIPPING: GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS';
export const GET_INSIDE_SHIP_TO_ADDRESS_FAILURE =
    'SHIPPING: GET_INSIDE_SHIP_TO_ADDRESS_FAILURE';

export const GET_SHIPPING_METHODS_REPORT_USAGE =
    'SHIPPING: GET_SHIPPING_METHODS_REPORT_USAGE';

export const GET_OUTSIDE_SHIPPING_METHODS_SUCCESS =
    'SHIPPING: GET_OUTSIDE_SHIPPING_METHODS_SUCCESS';
export const GET_OUTSIDE_SHIPPING_METHODS_FAILURE =
    'SHIPPING: GET_OUTSIDE_SHIPPING_METHODS_FAILURE';

export const GET_INSIDE_SHIPPING_METHODS_SUCCESS =
    'SHIPPING: GET_INSIDE_SHIPPING_METHODS_SUCCESS';
export const GET_INSIDE_SHIPPING_METHODS_FAILURE =
    'SHIPPING: GET_INSIDE_SHIPPING_METHODS_FAILURE';

export const RESET_REPLENE_SHIPPING_METHOD =
    'SHIPPING: RESET_REPLENE_SHIPPING_METHOD';

export const CLEAR_OUTSIDE_SHIPPING_ADDRESS =
    'SHIPPING: CLEAR_OUTSIDE_SHIPPING_ADDRESS';
export const CLEAR_INSIDE_SHIPPING_ADDRESS =
    'SHIPPING: CLEAR_INSIDE_SHIPPING_ADDRESS';
export const GET_OUTSIDE_ACCOUNT = 'SHIPPING: GET_OUTSIDE_ACCOUNT';

export const SET_REMOVE_APPLIED_SIGNATURE =
    'USAGE: SET_REMOVE_APPLIED_SIGNATURE';

export const GET_DISCREPANCY_DATA = 'USAGE: GET_DISCREPANCY_DATA';
export const GET_DISCREPANCY_DATA_SUCCESS =
    'USAGE: GET_DISCREPANCY_DATA_SUCCESS';
export const GET_DISCREPANCY_DATA_FAILURE =
    'USAGE: GET_DISCREPANCY_DATA_FAILURE';

export const USAGE_DISCREPANCY_ATTACHMENT_UPLOAD =
    'USAGE: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD';
export const USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS =
    'USAGE: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS';
export const USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE =
    'USAGE: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE';

export const DELETE_DISCREPANCY_ATTACHMENT_REQUEST =
    'USAGE: DELETE_DISCREPANCY_ATTACHMENT_REQUEST';
export const DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS =
    'USAGE: DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS';
export const DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE =
    'USAGE: DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE';
export const RESET_DISCREPANCY_ATTACHMENT =
    'USAGE : RESET_DISCREPANCY_ATTACHMENT';
export const CHECK_IS_PRICEOVERRIDE_PAGE = 'USAGE: CHECK_IS_PRICEOVERRIDE_PAGE';
export const STORE_USAGE_DATA_PERSIST = 'USAGE: STORE_USAGE_DATA_PERSIST';
export const PUT_DISCREPANCY_DATA_REQUEST =
    'USAGE: PUT_DISCREPANCY_DATA_REQUEST';
export const PUT_DISCREPANCY_DATA_REQUEST_SUCCESS =
    'USAGE: PUT_DISCREPANCY_DATA_REQUEST_SUCCESS';
export const PUT_DISCREPANCY_DATA_REQUEST_FAILURE =
    'USAGE: PUT_DISCREPANCY_DATA_REQUEST_FAILURE';
export const UPDATE_DIS_ATTACHMENT = 'USAGE:UPDATE_DIS_ATTACHMENT';
//To store the accounts payload
export const GET_DISTRICT_TERRITORY = 'USAGE: GET_DISTRICT_TERRITORY';
export const SET_PROCEDURE_DATA = 'USAGE: SET_PROCEDURE_DATA';
export const SET_RETRACTOR_USED_OTHER_FIELD_DATA =
    'USAGE: SET_RETRACTOR_USED_OTHER_FIELD_DATA';
export const TOTAL_LEVELS_NUMBER = 'USAGE: TOTAL_LEVELS_NUMBER';
export const UIV_FIRST_LEVEL_SELECTED = 'USAGE: UIV_FIRST_LEVEL_SELECTED';
export const LIV_FIRST_LEVEL_SELECTED = 'USAGE: LIV_FIRST_LEVEL_SELECTED';
export const UIV_LEVEL_ARRAY = 'USAGE: UIV_LEVEL_ARRAY';
export const LIV_LEVEL_ARRAY = 'USAGE: LIV_LEVEL_ARRAY';
export const SET_LEVEL_NUMBER_ARRAY = 'USAGE: SET_LEVEL_NUMBER_ARRAY';
export const SET_CURR_UIV_LEVEL = 'USAGE: SET_CURR_UIV_LEVEL';
export const SET_CURR_LIV_LEVEL = 'USAGE: SET_CURR_LIV_LEVEL';
export const SET_CURR_ROW_ID = 'USAGE: SET_CURR_ROW_ID';
export const SET_PREV_PROCEDURE_ROW_LEVELS =
    'USAGE: SET_PREV_PROCEDURE_ROW_LEVELS';
export const SET_PHYSICIAN_PROCEDURE_DROPDOWN =
    'USAGE: SET_PHYSICIAN_PROCEDURE_DROPDOWN';
export const SET_PHYSICIAN_TEXT_DATA = 'USAGE: SET_PHYSICIAN_TEXT_DATA';
export const SET_MAZOR_CASE_COVERAGE_VALUE = 'SET_MAZOR_CASE_COVERAGE_VALUE';
export const RESET_MAZOR_CASE_COVERAGE_VALUE =
    'RESET_MAZOR_CASE_COVERAGE_VALUE';
export const SET_UIV_DROPDOWN_VALUE = 'SET_UIV_DROPDOWN_VALUE';
export const SET_LIV_DROPDOWN_VALUE = 'SET_LIV_DROPDOWN_VALUE';
export const SET_IS_UIV_SELECTED = 'SET_IS_UIV_SELECTED';
export const SET_IS_LIV_SELECTED = 'SET_IS_LIV_SELECTED';
export const ADD_PROCEDURE_LEVEL = 'ADD_PROCEDURE_LEVEL';
export const SET_PROCEDURE_LEVEL = 'SET_PROCEDURE_LEVEL';
export const RESET_PROCEDURE_DATA = 'USAGE:RESET_PROCEDURE_DATA';
export const CHECK_ERROR_FOUND_IN_FIRST_LEVEL =
    'CHECK_ERROR_FOUND_IN_FIRST_LEVEL';
export const CHECK_LEVEL_DATA_MODIFIED = 'LEVEL:CHECK_LEVEL_DATA_MODIFIED';
export const CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL =
    'CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL';
export const CHECK_FIRST_LEVEL_SELECTED = 'CHECK_FIRST_LEVEL_SELECTED';
export const SET_SHIP_TO_ADDRESS_DETAILS = 'USAGE: SET_SHIP_TO_ADDRESS_DETAILS';
export const SET_DISCREPANCY_EMAIL = 'USAGE: SET_DISCREPANCY_EMAIL';
export const USAGE_SUBMIT_CLICKED = 'USAGE_SUBMIT_CLICKED';
export const SET_DISCREPANCY_USAGE_VALUE_EXISTS =
    'USAGE: SET_DISCREPANCY_USAGE_VALUE_EXISTS';
export const GET_ORDER_STATUS_DETAILS = 'USAGE: GET_ORDER_STATUS_DETAILS';
export const GET_ORDER_STATUS_DETAILS_SUCCESS =
    'USAGE: GET_ORDER_STATUS_DETAILS_SUCCESS';
export const GET_ORDER_STATUS_DETAILS_FAILURE =
    'USAGE: GET_ORDER_STATUS_DETAILS_FAILURE';
export const SET_IS_CONFIRMATION_BOX_CHECKED =
    'USAGE: SET_IS_CONFIRMATION_BOX_CHECKED';
export const REPORT_USG_OBJ = 'USAGE: REPORT_USG_OBJ';
export const RESET_DISCREPANCY_USAGE_DETAILS =
    'RESET_DISCREPANCY_USAGE_DETAILS';
export const SET_PROCEDURE_DATA_JP = 'SET_PROCEDURE_DATA_JP';
export const SET_PROCEDURE_VISIBILITY = 'SET_PROCEDURE_VISIBILITY';
export const SET_REQUEST_DELIVERY_DATE = 'USAGE:SET_REQUEST_DELIVERY_DATE';
export const SET_REPORT_PAYMENT_SCREEN = 'SET_REPORT_PAYMENT_SCREEN';
export const SET_REPORT_PAYMENT_FLAG = 'SET_REPORT_PAYMENT_FLAG';
export const SET_IS_ERROR_EXIST = 'SET_IS_ERROR_EXIST';
// export const CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED =
//     'CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED';
// export const CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED =
//     'CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED';
export const GET_TRANSFER_RECIPIENT_METHODS =
    'USAGE: GET_TRANSFER_RECIPIENT_METHODS';
export const SET_REPLENISHMENT_SURGERY_NUMBER =
    'USAGE:SET_REPLENISHMENT_SURGERY_NUMBER';
export const GET_TRANSFER_RECIPIENT_METHODS_SUCCESS =
    'USAGE: GET_TRANSFER_RECIPIENT_METHODS_SUCCESS';
export const GET_TRANSFER_RECIPIENT_METHODS_FAILURE =
    'USAGE: GET_TRANSFER_RECIPIENT_METHODS_FAILURE';
export const CLEAR_TRANSFER_RECIPIENTS = 'USAGE: CLEAR_TRANSFER_RECIPIENTS';
export const CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED =
    'CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED';
export const CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED =
    'CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED';
export const SET_TERRITORY = 'SET_TERRITORY';
//StealthAxis
export const VALIDATE_STEALTH_AXIS_CODE_RESPONSE =
    'USAGE:VALIDATE_STEALTH_AXIS_CODE_RESPONSE';
export const SET_STEALTH_AXIS_KIT_CODE = 'USAGE:SET_STEALTH_AXIS_KIT';
export const SET_STEALTH_CASE_COVERAGE_VALUE = 'USAGE:SET_STEALTH_CASE_COVERAGE_VALUE';
export const RESET_STEALTH_CASE_COVERAGE_VALUE =
    'USAGE:RESET_STEALTH_CASE_COVERAGE_VALUE';
export const VALIDATE_STEALTH_CODE = 'USAGE: VALIDATE_STEALTH_CODE';
export const REPORT_PAYMENT_CLICKED = 'USAGE: REPORT_PAYMENT_CLICKED';
export const PAGE_LOADER = 'USAGE: PAGE_LOADER';